import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

// Lean nav on purpose. This baseline prototype is about the two finding detail
// panels, not the surrounding app chrome, so the menu carries the one live
// entry — Findings — that lands on the comparison canvas. The full Portal nav
// mirror can come later if we want the "same app" feel; for now it would just
// be placeholder noise.
export const dev18689GhostlabMatchesNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.dev_18689_ghostlab_matches_finding, {
      displayName: 'Findings',
      icon: SolIcon.finding,
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
